import React, { ReactElement } from "react";

import GeneralSettings from "./generalSettings";
import TrackSettings from "./trackSettings";
import SessionSettings from "./sessionSettings";
import PollSettings from "./pollSetting";

export default (): ReactElement => {
  return (
    <>
      <GeneralSettings />
      <TrackSettings />
      <SessionSettings />
      <PollSettings />
    </>
  );
};
